export const SET_PLATFORM_LANGUAGE = 'SET_PLATFORM_LANGUAGE';
